export default function DeprecatedDocs() {
  // ANSWER FRAGMENT: AIN

  return (
    <div className="page">
      <h2>Deprecated Configuration</h2>
      <p data-fragment="AIN">
        This configuration is no longer supported.
      </p>
    </div>
  );
}
